// apps/client/src/net/handlers/chat.ts (M0-T19, §8.6) — the log takes every line; bubbles only for speakers in my space
import type { NetHandlers } from '../../game/game';
import { useGame } from '../../state/store';
export const handlers: NetHandlers = {
  onSnapshot: (snap) => useGame.getState().chatSetLines(snap.chat),
  events: {
    'chat.said': (e, game) => {
      const s = useGame.getState();
      const me = s.you?.resident;
      const sameSpace = e.line.r === me || s.presence[e.line.r]?.space === s.space;
      s.chatAdd(e.line, sameSpace, game.socket?.clock.now() ?? Date.now());
      game.sound.sfx('chatPop');
    },
    'emote.played': (e, game) => {
      const avatar = game.avatarOf(e.r);                          // only residents in my space have one
      avatar?.play(e.emote);
      if (avatar) useGame.getState().emoteShow(e.r, e.emote, game.socket?.clock.now() ?? Date.now());
      game.sound.sfx('emote');
    },
  },
};
